import { render } from "./MessagesOverview.vue?vue&type=template&id=3515d5d4"
import script from "./MessagesOverview.vue?vue&type=script&lang=js"
export * from "./MessagesOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__